// extracted by mini-css-extract-plugin
export default {"domainCard":"styles_domainCard__6zXbM","domainIcon":"styles_domainIcon__XUppt"};